<template>
	<div class="courseware-body">
		<div class="ability-detail-header" @click="$router.go(-1)"><i class="el-icon-arrow-left" _m="r-5px" style="font-weight: 1000;"></i>返回</div>
		<div class="top">
			<span class="top-half">
				<img :src="detailData.cover_path?.url" width="50" height="68" />
				<span style="margin-left: 30px;white-space:nowrap">
					<div class="top-black-text">{{ detailData.text_name }}</div>
					<div class="top-grey-text" _flex="~">
						{{
							`${filteLabel(detailData.text_classgrade, apply_grade)}       ${filteLabel(
								detailData.text_volume,
								fb_apply_volume
							)}`
						}}
						<el-dropdown @command="handleCommand" placement="bottom">
							<div _cursor="pointer" _flex="~">
								<i class="el-icon-sort" style="margin-left: 15px; margin-right: 5px; transform: rotate(90deg);"></i>
								<div>切换</div>
							</div>
							<el-dropdown-menu
								slot="dropdown"
								v-infinite-scroll="loadMoreData"
								infinite-scroll-disabled="loading"
								:infinite-scroll-distance="20"
								:style="{ height: '400px', 'overflow-y': 'auto', 'min-width': '400px' }"
							>
								<el-dropdown-item
									v-for="item in tableData"
									:key="item.id"
									:command="item.id"
									:style="{ color: textbook_id == item.id ? '#FF5E2A' : '' }"
								>
									<div _flex="~ items-center justify-between" _m="b-3">
										<img :src="item.cover_path?.url" width="50" height="68" _m="r-3" />
										<div _flex="1">{{ item.text_name }}</div>
										<i v-show="textbook_id == item.id" class="el-icon-check"></i>
									</div>
								</el-dropdown-item>
								<div v-if="loading" _flex="~ items-center justify-center" _text="[#FF5E2A]">
									<i class="el-icon-loading"></i><span>加载中</span>
								</div>
								<!-- <div v-if="ending" _flex="~ items-center justify-center" _text="[#FF5E2A]">没有更多了~</div> -->
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</span>
        <div _flex="~ items-baseline" _p="t- 36px l-60px b-20px" v-if="detailData.author">
          <div _text="[#969696] 16px" style="white-space:nowrap">制作者：</div>
          <!-- <el-tooltip class="item" effect="light" :content="detailData.author" placement="top">
            <span style="cursor:pointer;text-overflow: ellipsis;white-space: nowrap" _overflow="hidden" _text="overflow-ellipsis">{{ detailData.author?.length > 25 ?  `${detailData.author.substring(0, 25)}...` : detailData.author }}</span>
          </el-tooltip> -->
          <div>{{  detailData.author }}</div>
        </div>
			</span>
			<!-- <span class="top-line"></span> -->
      <!-- <span class="top-half"></span> -->
			<!-- <span class="top-half">
				<img :src="require('@/assets/image/PDF.png')" width="64" height="64" />
				<span style="margin-left: 30px;">
					<div class="top-black-text">电子教材</div>
					<div class="top-blue-text">
						<span
							style="margin-right: 10px; cursor: pointer;"
							@click="openPageLook(detailData.book_path?.url)"
							v-if="$permissions([`SP4000_${yy_ms}_8`])"
						>
							<i class="el-icon-view" style="margin-right: 7px;"></i>查看
						</span>
						<span
							style="cursor: pointer;"
							@click="editTextbook"
							v-if="
								($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && detailData.is_admin) ||
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && detailData.is_owner) ||
								($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_9`])) ||
                ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && detailData.is_owner)
							"
						>
							<i class="el-icon-sort" style="margin-right: 7px; transform: rotate(90deg);"></i>替换
						</span>
					</div>
				</span>
			</span> -->
		</div>
		<div class="content">
			<div class="left">
				<div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
					<span class="left-title">目录</span>
					<div>
						<el-button
							size="small"
							type="primary"
							@click="addEvent"
							v-if="
								($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && detailData.is_admin) ||
                ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && detailData.is_owner) ||
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && detailData.is_owner) ||
								($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_11`]))
							"
						>
							<i class="el-icon-plus" style="margin-right: 7px;"></i>新建
						</el-button>
						<el-button
							@click=";(draggable = !draggable), (treeEditFlag = !treeEditFlag)"
							size="small"
							v-if="
								($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && detailData.is_admin) ||
                ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && detailData.is_owner) ||
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && detailData.is_owner) ||
								($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_12`]))
							"
						>
							<i class="el-icon-edit" style="margin-right: 7px;"></i>{{ !treeEditFlag ? '编辑' : '退出' }}
						</el-button>
					</div>
				</div>
				<el-tree
					:data="directory"
					:props="defaultProps"
					ref="treeRef"
					node-key="id"
					:draggable="draggable"
					:expand-on-click-node="true"
					@node-drag-start="handleDragStart"
					@node-drag-enter="handleDragEnter"
					@node-drag-leave="handleDragLeave"
					@node-drag-over="handleDragOver"
					@node-drag-end="handleDragEnd"
					@node-drop="handleDrop"
					:allow-drop="allowDrop"
					@node-click="treeNodeEvenet"
					:default-expanded-keys="expandList"
				>
					<span
						class="tree-node"
						:style="treeId === data.id ? 'align-items:center' : 'align-items: flex-end'"
						slot-scope="{ node, data }"
					>
						<el-input
							:class="`node-content node-content-${node.level}`"
							@change="treeInputChange(node, data, $event)"
							@blur="treeInputBlur(node, data, $event)"
							:ref="`input_${data.id}`"
							v-if="treeId === data.id"
							v-model="treeInputText"
							placeholder=""
							size="small"
						></el-input>
            <!-- 傻逼产品又不要了，之前的需求如此实现---选中上级一起高亮的需求~产品又提bug了哦 -->
            <!-- (activeTreeId === data.id || activeTreeIdArray.includes(data.id)) -->
						<span
							:class="['node-content', `node-content-${node.level}`, activeTreeId === data.id && 'node-content-active']"
							v-else
              @drop="A_drop($event, data, node)" @dragover="A_allowDrop($event, data)"
							>{{ node.label }}</span
						>
						<div v-show="treeEditFlag" _m="l-12px" @click.stop>
							<span
								@click.stop="treeSwapEvent(node, data, 'before')"
								_m="r-12px"
								:class="treeId === data.id && 'node-stop'"
								v-if="data.order_num > 1"
							>
								<svg-icon iconClass="up" className="delete-icon" :class="`node-icon-${node.level}`"></svg-icon>
							</span>
							<span
								@click.stop="treeSwapEvent(node, data, 'after')"
								_m="r-12px"
								:class="treeId === data.id && 'node-stop'"
								v-if="node.parent.childNodes.length > data.order_num"
							>
								<svg-icon iconClass="down" className="delete-icon" :class="`node-icon-${node.level}`"></svg-icon>
							</span>
							<span @click.stop=";(treeType = 'edit'), onloadInput(node, data)" _m="r-12px" v-if="treeId !== data.id">
								<svg-icon iconClass="edit1.3.1" className="delete-icon" :class="`node-icon-${node.level}`"></svg-icon>
							</span>
							<span _m="r-12px" v-else>
								<svg-icon iconClass="edit1.3.1-color" className="delete-icon" :class="`node-icon-${node.level}`"></svg-icon>
							</span>
							<span
								_z="9"
								@click.stop="treeDeleteEvent(node, data)"
								_m="r-12px"
								:class="treeId === data.id && 'node-stop'"
							>
								<svg-icon iconClass="remove1.3.1" className="delete-icon" :class="`node-icon-${node.level}`"></svg-icon>
							</span>
							<span
								@click="treeAddEvent(node, data)"
								v-show="node.level < 4 && node.level < dict_level"
								:class="treeId === data.id && 'node-stop'"
							>
								<svg-icon iconClass="add1.3.1" className="delete-icon" :class="`node-icon-${node.level}`"></svg-icon>
							</span>
						</div>
					</span>
				</el-tree>
			</div>

			<div class="right">
				<div class="right-header">
          <div _flex="~ justify-between" _h="35px">
            <span class="left-title">课件</span>
            <div>
              <span v-if="courses[menuActiveIndex].length > 0 && $store.state.user.userInfo.type !== $api.account.types.SCHOOL_ADMIN.value" _m="r-10px">
                <el-button
                  size="small"
                  @click="courseEditFlag = !courseEditFlag"
                  v-if="
                    ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_14`])) ||
                    $store.state.user.userInfo.type === $api.account.types.TEACHER.value ||
                    $store.state.user.userInfo.type === $api.account.types.RESEARCH.value ||
                    $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value
                  "
                >
                  <i class="el-icon-edit" style="margin-right: 7px;"></i>{{ !courseEditFlag ? '编辑' : '退出' }}
                </el-button>
                <el-button
                  size="small"
                  :disabled="(!courseEditFlag || courseRadio.length <= 0)"
                  @click="deleteCourse"
                  v-if="
                    courseEditFlag && (($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_14`])) ||
                    $store.state.user.userInfo.type === $api.account.types.TEACHER.value ||
                    $store.state.user.userInfo.type === $api.account.types.RESEARCH.value ||
                    $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value)
                  "
                >
                  <i class="el-icon-delete" style="margin-right: 7px;"></i>删除
                </el-button>
                <el-button
                  size="small"
                  type="primary"
                  @click="openMpptxSystem(direct_name)"
                  v-if="
                    !courseEditFlag &&
                    level == dict_level &&
                    (
                      $store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_15`]) ||
                      $store.state.user.userInfo.type === $api.account.types.TEACHER.value ||
                      $store.state.user.userInfo.type === $api.account.types.RESEARCH.value ||
                      $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value
                    )
                  "
                >
                  <i class="el-icon-plus" style="margin-right: 7px;"></i>新建
                </el-button>
              </span>
              <el-button
                icon="el-icon-download" size="small" style="margin-right: 12px" @click="uploadPPT()"
                v-if="
                  courses[menuActiveIndex].length > 0 &&
                  !courseEditFlag &&
                  level == dict_level &&
                  (
                    ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_16`])) ||
                    $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value
                  )
                "
                :loading="courseStauts"
              >导入</el-button>
            </div>
          </div>
          <el-menu
            v-if="
              ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && detailData.is_admin) ||
              ($store.state.user.userInfo.type === $api.account.types.OTHER.value)
            "
            :default-active="menuActiveIndex" class="caogao-menu" mode="horizontal" @select="menuSelectEvent"
          >
            <el-menu-item index="courses">{{ `已发布（${menuActiveTotal['courses']}）` }}</el-menu-item>
            <el-menu-item index="draft">{{ `草稿（${menuActiveTotal['draft']}）` }}</el-menu-item>
          </el-menu>
				</div>

        <!-- 已发布列表 -->
        <div _pos="relative">
          <el-checkbox-group
            v-model="courseRadio"
            :class="['right-content', menuActiveIndex == 'courses' ? 'slide-fade-enter' : 'slide-fade-leave']"
            v-infinite-scroll="loadMoreCourses"
            infinite-scroll-disabled="courseLoading"
            :infinite-scroll-distance="20"
          >
            <div v-for="(item, index) in courses[menuActiveIndex]" :key="index" class="content-item"
              :draggable="item.can_move"
              @dragstart="A_dragstart($event, { id: item.id, name: item.course_name })"
              @dragend="B_dragend($event, { id: item.id, name: item.course_name, index: index })"
              @dragover.prevent="B_dropover($event, { id: item.id, name: item.course_name, index: index })"
            >
              <el-checkbox
                :disabled="!item?.account?.can_del"
                v-if="courseEditFlag"
                class="item-radio"
                :label="item?.id || index"
              ></el-checkbox>
              <img :draggable="false" :src="item?.cover_path?.url" width="100%" style="margin-bottom: 5px; height: 170px;" />
              <div :draggable="false" class="item-date">{{ item?.created_at }}</div>
              <div :draggable="false" _flex="~" style="justify-content: space-between; align-items: center;">
                <div class="item-name">{{ item?.course_name }}</div>
                <div class="item-name" style="justify-content: end; font-size: 13px;" _flex="~">
                  {{ item?.classgrade ? item?.classgrade?.class_name : '' }}
                </div>
              </div>
              <div style="display: flex; align-items: center;">
                <img :src="item?.account?.avatar?.url || 'https://file.xinhuomy.com/default.png'" width="28px" height="28px" style="border-radius: 100%;" />
                <span class="item-avtor">{{
                  $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                  $store.state.user.userInfo.type === $api.account.types.OTHER.value
                    ? item?.account?.realname
                    : item?.is_admin
                    ? '基础课件'
                    : item?.account?.realname
                }}</span>

                <el-button
                  size="small"
                  type="primary"
                  @click="enterMpptxSystem(item)"
                  round
                  >进入</el-button
                >
                <!-- v-if="
                  $store.state.user.userInfo.type !== $api.account.types.SCHOOL_ADMIN.value &&
                  (
                    $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                    $store.state.user.userInfo.type === $api.account.types.RESEARCH.value ||
                    $store.state.user.userInfo.type === $api.account.types.TEACHER.value
                  )
                " -->
              </div>
            </div>
          </el-checkbox-group>

          <!-- 草稿列表 -->
          <el-checkbox-group
            v-model="courseRadio"
            :class="['right-content', menuActiveIndex == 'draft' ? 'slide-fade-enter' : 'slide-fade-leave']"
            v-infinite-scroll="loadMoreCourses"
            infinite-scroll-disabled="courseLoading"
            :infinite-scroll-distance="20"
          >
            <div v-for="(item, index) in courses[menuActiveIndex]" :key="index" class="content-item">
              <el-checkbox
                v-if="courseEditFlag"
                class="item-radio"
                :label="item?.id || index"
              ></el-checkbox>
              <div _pos="relative">
                <div _pos="absolute" _flex="~ items-center justify-center" _w="50px" _h="30px" _text="16px [#FFFFFF]" class="item-draft">草稿</div>
                <img :draggable="false" :src="item?.cover_path?.url" width="100%" style="margin-bottom: 5px; height: 170px;" />
              </div>
              <div :draggable="false" class="item-date">{{ item?.created_at }}</div>
              <div :draggable="false" _flex="~" style="justify-content: space-between; align-items: center;">
                <div class="item-name">{{ item?.course_name }}</div>
                <div class="item-name" style="justify-content: end; font-size: 13px;" _flex="~">
                  {{ item?.classgrade ? item?.classgrade?.class_name : '' }}
                </div>
              </div>
              <div style="display: flex; align-items: center;">
                <img :src="item?.account?.avatar?.url || 'https://file.xinhuomy.com/default.png'" width="28px" height="28px" style="border-radius: 100%;" />
                <span class="item-avtor">{{
                  $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                  $store.state.user.userInfo.type === $api.account.types.OTHER.value
                    ? item?.account?.realname
                    : item?.is_admin
                    ? '基础课件'
                    : item?.account?.realname
                }}</span>

                <div
                  class="grey-btn"
                  _w="56px"
                  _h="32px"
                  @click="draftPublish(item)"
                  >发布</div
                >
                <el-button
                  size="small"
                  type="primary"
                  @click="enterMpptxSystem(item)"
                  round
                  >进入</el-button
                >
              </div>
            </div>
          </el-checkbox-group>
        </div>

				<div v-if="courses[menuActiveIndex].length <= 0" class="right-empty">
					<img :src="require('@/assets/image/empty.png')" class="empty-icon" />
          <div>
            <el-button
              size="small"
              type="primary"
              @click="openMpptxSystem(direct_name)"
              v-if="
                activeTreeId != '' &&
                level == dict_level &&
                $store.state.user.userInfo.type !== $api.account.types.SCHOOL_ADMIN.value &&
                (
                  ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_15`])) ||
                  $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                  $store.state.user.userInfo.type === $api.account.types.RESEARCH.value ||
                  $store.state.user.userInfo.type === $api.account.types.TEACHER.value
                )
              "
            >
              <i class="el-icon-plus" style="margin-right: 7px;"></i>新建课件
            </el-button>
            <el-button size="small"  @click="uploadPPT"
              v-if="
                level == dict_level &&
                (
                  ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP4000_${yy_ms}_16`])) ||
                  $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value
                )
              "
              :loading="courseStauts"
            ><i class="el-icon-download" style="margin-right: 7px;"></i>导入课件</el-button>
          </div>
				</div>

				<div v-else>
					<div v-if="courseLoading" _flex="~ items-center justify-center" _text="[#FF5E2A]" _m="b-5">
						<i class="el-icon-loading"></i><span>加载中</span>
					</div>
					<!-- <div v-if="courseEnding" _flex="~ items-center justify-center" _text="[#FF5E2A]" _m="b-5">没有更多了~</div> -->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { cloneDeep } from 'lodash'
import { apply_grade, fb_apply_volume } from './const.js'
import { uploadFileEvent, uploadMoreFileEvent } from './UploadEvent.js'
// import JSZip from 'jszip';
import ZIP from '@zip.js/zip.js/dist/zip'
import { importMDF } from '@/utils/job.js'
export default {
	components: {},
	data() {
		return {
      menuActiveIndex: 'courses', // courses已发布|draft草稿
      menuActiveTotal: {
        'courses': 0,
        'draft': 0
      },
      menuActivePage: {
        'courses': 0,
        'draft': 0
      },
      dragCourseId: null,
      dragCourseName: null,
      // dragDirectName: null,
			mpptxUrl: '',
			apply_grade,
			fb_apply_volume,
			detailData: {},
			directory: [],
			others: [],
			defaultProps: {
				label: 'direct_name',
				children: 'children'
			},
			treeEditFlag: false,
			textbook_id: '',
			treeId: '',
			treeInputText: '',
			treeType: '',
			activeTreeId: '',
			courses: {
        'courses': [],
        'draft': []
      },
			courseRadio: [],
			courseEditFlag: false,
			expandList: [],
			params: {},
			tableData: [],
			total: '',
			loading: false,
			ending: false,
			token: '',
			courseLoading: false,
			courseEnding: false,
			draggable: false,
			level: 1,
			dict_level: null,
      activeTreeIdArray: [],
      B_drop: {},
			userId: null,
      courseStauts: false
		}
	},
	created() {
		this.mpptxUrl = `${window.web_config.api_url}${window.web_config.mpptx_path}`
		// this.mpptxUrl = `${window.web_config.api_url}/mppt`
		this.token = JSON.parse(window.localStorage.getItem('tokenInfo')).access_token
		this.userId = JSON.parse(window.localStorage.getItem('accountInfo'))?.id
		this.params = JSON.parse(window.localStorage.getItem('books'))
		this.initPage()
	},
	methods: {
    // 获取目录课件数量（发布|草稿）
    async getAllNumber() {
      const { draft, real } = await this.$api.resource.getAllNumber({ did: this.activeTreeId })
      this.menuActiveTotal['draft'] = draft
      this.menuActiveTotal['courses'] = real
    },
    // 发布课件
    draftPublish(item) {
      const pushMPPTX = () => {
        this.$api.resource.draftPublish(item.id).then(() => {
          this.$message.success('发布成功')
          this.getCourses({ did: this.activeTreeId, page_size: 10, page: 1 }, 'reset')
        })
      }
      if (!item.course_id) {
        pushMPPTX()
        return
      }
      this.$confirm('该操作将会发布该课件是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
        pushMPPTX()
      })
    },
    menuSelectEvent(type) {
      this.courseRadio = [] // 清空多选已选择的选项
      this.courseEditFlag = false // 退出编辑状态
      this.menuActiveIndex = type
      this.getCourses({ did: this.activeTreeId, page_size: 10, page: 1 }, 'reset')
    },
    A_allowDrop(ev, data) {
      if (data.level == this.dict_level) {
        ev.preventDefault();
        return false
      } else {
        this.expandList.push(data.id)
        return true
      }
    },
    A_dragstart(ev, { id, name }) {
      console.log('课件开始被拖拽~', ev)
      this.dragCourseId = id
      this.dragCourseName = name
    },
    async A_drop(ev, data, node) {
      console.log('课件拖拽最后松开停留', ev, data)
      this.$confirm(`是否将 ${this.dragCourseName} 课件移动至 ${data.direct_name} 教材目录下?`, '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					const { success } = await this.$api.resource.mpptxDrop(this.dragCourseId, data.id)
          if (success) {
            this.treeNodeEvenet(data, node)
          }
				})
        .catch(() => {
        })
    },
     B_dropover(_, data) {
      if (this.dragCourseId == data.id && this.B_drop?.id == data.id) return
      this.B_drop = data
    },
    async B_dragend(ev, data) {
      const el = document.querySelector('.right-content')
      const checkboxGroupRect = el.getBoundingClientRect()
      if ( ev.pageX < checkboxGroupRect.left || ev.pageX > checkboxGroupRect.right || ev.pageY < checkboxGroupRect.top || ev.pageY > checkboxGroupRect.bottom) return
      if (!this.courseEditFlag) return
      this.$confirm(`该操作将会移动课件先后顺序，是否继续?`, '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
        .then(async () => {
          const courses = cloneDeep(this.courses[this.menuActiveIndex])
          const itemToMove = courses.splice(data.index, 1)[0]
          courses.splice(this.B_drop.index, 0, itemToMove)
          const ids = courses.map(item => item.id)
          const { success } = await this.$api.resource.mpptxChangePostion({
            ids: ids
          })
          if (success) {
            const itemToMove = this.courses[this.menuActiveIndex].splice(data.index, 1)[0];
            this.courses[this.menuActiveIndex].splice(this.B_drop.index, 0, itemToMove);
          }
        })
    },
		// 打开mpptx系统~
		async openMpptxSystem(item) {
			let mpptxNameValue = item
			const data = await this.$api.resource.checkMpptxName({
				keyword: item
			})
			if (!data.success) {
				const regex = /(?<=\（)(.+?)(?=\）)/g
				// const regexAll = /\（(.+?)\）/g
				const regexNum = mpptxNameValue.match(regex)
				if (regexNum) mpptxNameValue = `${mpptxNameValue.split('（')[0]}（${Number(regexNum[0]) + 1}）`
				else mpptxNameValue = `${mpptxNameValue}（${1}）`
			}
			this.openPageLook(
				`${this.mpptxUrl}?isDraft=${this.menuActiveIndex == 'draft' ? 1 : 0}&user_id=${this.userId}&subjectId=${this.params.fb_subject_id}&isPublic=${this.detailData.has_private}&textbookId=${this.textbook_id}&textbookDirectoryName=${mpptxNameValue}&textbookDirectoryId=${this.activeTreeId}&token=${this.token}`
			)
		},
    enterMpptxSystem(item) {
      // 基础课件（管理员、教研） ||  是否个人的课件
      let path
      if (item.is_admin || item.is_assistent || item?.is_owner || (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value && this.params.scope_type == 4)) {
        path = `${this.mpptxUrl}?isDraft=${this.menuActiveIndex == 'draft' ? 1 : 0}&user_id=${this.userId}&isSaveAs=${item?.is_owner ? false : true}&subjectId=${this.params.fb_subject_id}&isPublic=${this.detailData.has_private}&textbookId=${this.textbook_id}&textbookDirectoryId=${this.activeTreeId}&mpptxId=${item.id}&token=${this.token}`
      } else {
        path = `${this.mpptxUrl}?isDraft=${this.menuActiveIndex == 'draft' ? 1 : 0}&user_id=${this.userId}&isSaveAs=${false}&isScreening=${true}&subjectId=${this.params.fb_subject_id}&isPublic=${this.detailData.has_private}&textbookId=${this.textbook_id}&textbookDirectoryId=${this.activeTreeId}&mpptxId=${item.id}&token=${this.token}`
      }
      // 变更，校管不管直接进入放映
      if (this.$store.state.user.userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
        path = `${this.mpptxUrl}?isDraft=${this.menuActiveIndex == 'draft' ? 1 : 0}&user_id=${this.userId}&isSaveAs=${false}&isScreening=${true}&subjectId=${this.params.fb_subject_id}&isPublic=${this.detailData.has_private}&textbookId=${this.textbook_id}&textbookDirectoryId=${this.activeTreeId}&mpptxId=${item.id}&token=${this.token}`
      }
      // 变更第3次，超管编辑访客课件
      if (this.$store.state.user.userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value && item?.account?.type == this.$api.account.types.OTHER.value) {
        path = `${this.mpptxUrl}?isDraft=${this.menuActiveIndex == 'draft' ? 1 : 0}&user_id=${this.userId}&isSaveAs=${false}&subjectId=${this.params.fb_subject_id}&isPublic=${this.detailData.has_private}&textbookId=${this.textbook_id}&textbookDirectoryId=${this.activeTreeId}&mpptxId=${item.id}&token=${this.token}`
      }
      this.openPageLook(path)
    },
		handleDragStart(node, ev) {
			console.log('drag start', node);
		},
		handleDragEnter(draggingNode, dropNode, ev) {
			console.log('tree drag enter: ', dropNode.label);
		},
		handleDragLeave(draggingNode, dropNode, ev) {
			console.log('tree drag leave: ', dropNode.label);
		},
		handleDragOver(draggingNode, dropNode, ev) {
			console.log('tree drag over: ', dropNode.label);
		},
		handleDragEnd(draggingNode, dropNode, dropType, ev) {
			this.swapDirectory(draggingNode.data.id, dropNode.data.id)
		},
		handleDrop(draggingNode, dropNode, dropType, ev) {
			console.log('tree drop: ', dropNode.label, dropType);
		},
		allowDrop(draggingNode, dropNode, type) {
      console.log('el-tree', draggingNode, dropNode, type)
			if (type === 'inner') {
				return false
			} else if (draggingNode.level !== dropNode.level) {
				return false
			} else {
				return true
			}
		},
		async loadMoreCourses() {
			if (this.menuActiveTotal[this.menuActiveIndex] <= this.courses[this.menuActiveIndex].length) {
				this.courseEnding = true
				this.courseLoading = false
				return
			}
			if (this.courseLoading) return // 如果正在加载数据，则退出
			this.courseLoading = true // 设置加载状态为true
			await this.getCourses({ did: this.activeTreeId, page_size: 10, page: this.menuActivePage[this.menuActiveIndex] + 1 }, 'load')
			this.courseLoading = false // 加载完成后，将加载状态设为false
		},
		async loadMoreData() {
			if (this.total <= this.tableData.length) {
				this.ending = true
				this.loading = false
				return
			}
			if (this.loading) return // 如果正在加载数据，则退出
			this.loading = true // 设置加载状态为true
			await this.getTextbooks({ ...this.params, page: this.params.page + 1, page_size: 6 }) // 将新数据添加到原有数据数组中
			this.loading = false // 加载完成后，将加载状态设为false
		},
		async handleCommand(id) {
			let path = `${this.$route.path}?id=${id}`
			this.textbook_id = id
			this.activeTreeId = ''
			this.expandList = []
			this.$router.replace(path)
			await this.getDirectory(id)
			this.niumaBianLi(this.directory, this.expandList)
			this.expandList = [this.expandList[this.expandList.length - 1]]
			this.courses[this.menuActiveIndex] = [] //一定要在最后，不然列表加载会加载旧的传参
		},
		openPageLook(uri) {
			window.open(`${uri}`)
		},
		filteLabel(value, array) {
			return array[array.findIndex(item => item.value == value)]?.label || '——'
		},
		async initPage() {
			const { id } = this.$route.query
			this.textbook_id = id
			this.getTextbooks({ ...this.params, page_size: 6 })
			await this.getDirectory(id)
			this.niumaBianLi(this.directory, this.expandList)
		},
		async getTextbooks(params) {
      const data = await this.$api.resource.getTextbooks(params)
			this.tableData = [...this.tableData, ...data.data]
			this.total = data.meta.total
			this.params.page = data.meta.current_page
		},
    formatbytes(bytes) {
			if (bytes === 0) return '0 B'
			const k = 1024
			const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
			const i = Math.floor(Math.log(bytes) / Math.log(k))
			return (bytes / Math.pow(k, i)).toPrecision(3) + '' + sizes[i]
		},
    async uploadPPT() {
      let index = 1
      const files = await uploadMoreFileEvent({  accept: '.mpptx', multiple: true })
      this.courseStauts = true
      let reader, readerZip
      for (const file of files) {
        try {
          const arr = file.name?.split('.')
          const type = arr[arr?.length - 1]
          if (type !== 'mpptx') throw new Error('文件格式不正确')
          readerZip = new ZIP.ZipReader(new ZIP.BlobReader(file), { password: 'midi_1edu_askdj21343' });
          const readerEntries = await readerZip.getEntries()
          const courseFiles = readerEntries.find(item => item.filename.indexOf('-') !== -1)
          if (!courseFiles) throw new Error('资源包内缺少课件资源')
          const courseContent = await courseFiles.getData(new ZIP.BlobWriter())
          reader = new ZIP.ZipReader(new ZIP.BlobReader(courseContent));
          const entries = await reader.getEntries()
          const courseFile = entries.find(item => item.filename == 'course')
          if (!courseFile) throw new Error('资源包内缺少关键文件course')
          const courseJSON = await courseFile.getData(new ZIP.TextWriter())
          const course = JSON.parse(courseJSON)
          if (!course.mpptx_json) throw new Error('资源文件course内缺少关键字段mpptx_json')
          const subject_id = course?.textbook?.subject_id || course?.directory?.textbook?.subject_id
          if (!subject_id) throw new Error('资源文件缺少关键学科')
          const yy_ms_text = (e) => e == 1 ? '音乐' : e == 2 ? '美术' : ''
          if (subject_id != this.params.fb_subject_id) throw new Error(`${yy_ms_text(this.params.fb_subject_id)}教材无法导入${yy_ms_text(subject_id)}课件`)
          const params = {
            textbook_id: this.textbook_id,
            textbook_directory_id: this.activeTreeId,
            course,
            is_draft: this.menuActiveIndex == 'draft' ? 1 : 0 // 导入区分发布、草稿
          }
          if (index == 1)this.$store.state.job.isDot = true
          index++
          const { id } = await this.$api.user.httpPost('ppt-import', params)
          let job = {
            job_id: id,
            name: file.name,
            type: 'PPT',
            size: this.formatbytes(file.size),
          }
          importMDF(this, job)
        } catch(err) {
          setTimeout(() => {
            this.$notify({
              title: `提示`,
              duration: 3500,
              dangerouslyUseHTMLString: true,
              message: `<b>${file.name} 导入失败</b> <br /><i style="color:red">${err}</i>`
            })
          }, files.findIndex(item => file.lastModified === item.lastModified) * 500 + 100)
        } finally {
          if (reader) reader.close()
          if (readerZip) readerZip.close()
        }
      }
      this.courseStauts = false
		},
		async editTextbook() {
			const { node } = await uploadFileEvent({ accept: 'application/pdf', api: this.$api.question_set.upload })
			const {
				cover_path,
				is_down,
				publisher_id,
				subject_id,
				text_classgrade,
				text_number,
				text_volume,
				text_name,
				id
			} = this.detailData
			const loading = this.$loading({
				lock: true,
				text: '请求中',
				spinner: 'el-icon-loading'
			})
			try {
				await this.$api.resource.editTextbook(id, {
					book_path: node,
					cover_path: cover_path?.node,
					is_down,
					publisher_id,
					subject_id,
					text_classgrade,
					text_number,
					text_volume,
					text_name
				})
				await this.getDirectory(this.textbook_id)
        this.$message.success('电子教材替换成功')
				loading.close()
			} catch (e) {
				loading.close()
			}
		},
		async swapDirectory(beforeId, afterId) {
			await this.$api2.resource.swapDirectory(beforeId, afterId)
			this.getDirectory(this.textbook_id)
		},
		handleNodeExpand(node) {
			// console.log(node)
		},
		async getDirectory(id) {
			const { info, others } = await this.$api2.resource.getDirectory(id)
			this.detailData = info
			this.sortTree(this.detailData.directory, (a, b) => {
				return a.order_num - b.order_num
			})
			this.directory = this.detailData.directory
			this.dict_level = this.detailData.dict_level
			this.others = others
		},
		niumaBianLi(arr, array) {
			if (arr[0].children?.length > 0) {
				array.push(arr[0].id)
        this.activeTreeIdArray.push(arr[0].id)
				this.niumaBianLi(arr[0].children, array)
			} else {
				this.treeNodeEvenet(arr[0])
			}
		},
		sortTree(data, sortFunction) {
			data.sort(sortFunction)
			for (let i = 0; i < data.length; i++) {
				const node = data[i]
				if (node.children && node.children.length > 0) {
					this.sortTree(node.children, sortFunction)
				}
			}
		},
		async createDirectory(params) {
			await this.$api.resource.createDirectory(params)
		},
		async deleteDirectory(id, params) {
			await this.$api2.resource.deleteDirectory(id, params)
		},
		async editDirectory(id, params) {
			await this.$api2.resource.editDirectory(id, params)
		},
		async getCourses(params, type) {
			this.courseLoading = true
      try {
        let data, meta
        // 已发布数据列表
        if (this.menuActiveIndex == 'courses') {
          const list = await this.$api.resource.getCourses(params)
          data = list.data
          meta = list.meta
        }
        // 草稿数据列表
        if (this.menuActiveIndex == 'draft') {
          // const list = await this.$api.resource.getCourses(params)
          const list = await this.$api.resource.getDrafts(params)
          data = list.data
          meta = list.meta
        }
        if (type == 'reset') {
          this.courses[this.menuActiveIndex] = [...data]
        } else {
          this.courses[this.menuActiveIndex] = [...this.courses[this.menuActiveIndex], ...data]
          this.courses[this.menuActiveIndex] = this.courses[this.menuActiveIndex].reduce((acc, cur) => {
            if (!acc.map.has(cur.id)) {
              acc.map.set(cur.id, cur);
              acc.result.push(cur);
            }
            return acc;
          }, { map: new Map(), result: [] }).result
        }
        this.menuActivePage[this.menuActiveIndex] = meta.current_page
        this.menuActiveTotal[this.menuActiveIndex] = meta.total
      } catch(err) {
        this.courses[this.menuActiveIndex] = []
      } finally {
				this.courseLoading = false
			}
		},
		treeNodeEvenet(data, node) {
      if (data.id > new Date().getTime() / 1000) return
			if (this.activeTreeId == data.id) return
      if (node) this.activeTreeIdArray = []
			this.direct_name = data.direct_name
			this.level = data.level
			this.activeTreeId = data.id
      this.$refs.treeRef.setCurrentKey(this.activeTreeId);
      this.addActiveTreeIdArray(node)
			this.expandList = []
			this.expandList.push(this.activeTreeId)
			this.courses = {
        'courses': [],
        'draft': []
      }
			this.courseRadio = []
			this.courseEditFlag = false
      this.getAllNumber()
			this.getCourses({ did: data.id, page_size: 10, page: 1 }, 'reset')
		},
    addActiveTreeIdArray(node) {
			this.activeTreeIdArray.push(node?.data?.id)
			if (node?.level > 1) this.addActiveTreeIdArray(node?.parent)
		},
		// onCollapseEvevnt(node) {
		// 	this.expandList.splice(this.expandList.indexOf(node.id), 1)
		// },
		// onExpandEvent(node) {
		// 	this.expandList.push(node.id)
		// },
		// treeStopEvent(){
		//   if (this.treeType === 'create') {
		//   }
		// },
		treeSwapEvent(node, data, type) {
			if (this.treeId != '') return
			const beforeId = node.parent.childNodes[data.order_num - 1 - 1]?.data?.id
			const afterId = node.parent.childNodes[data.order_num - 1 + 1]?.data?.id
			console.log(beforeId, data.id, afterId, data, node)
			// this.treeEditFlag = false
			if (type === 'before') {
				this.swapDirectory(beforeId, data.id)
				this.directorySwap(node, beforeId, data.id)
			} else if (type === 'after') {
				this.swapDirectory(data.id, afterId)
				this.directorySwap(node, data.id, afterId)
			}
		},
		directorySwap(node, beforeId, afterId) {
			// console.log(node, node.parent.data, '====')
			if (node.level == 1) {
				let beforeIndex = this.directory.findIndex(item => item.id == beforeId)
				let afterIndex = this.directory.findIndex(item => item.id == afterId)
				let tmp = this.directory[beforeIndex]
				this.directory[beforeIndex] = this.directory[afterIndex]
				this.directory[afterIndex] = tmp
			} else if (node.level == 2) {
				let zIndex = this.directory.findIndex(item => item.id == node.parent.data.id)
				// console.log(zIndex, this.directory[zIndex], '38293232363735')
				let beforeIndex = this.directory[zIndex].children.findIndex(item => item.id == beforeId)
				let afterIndex = this.directory[zIndex].children.findIndex(item => item.id == afterId)
				let tmp = this.directory[zIndex].children[beforeIndex]
				this.directory[zIndex].children[beforeIndex] = this.directory[zIndex].children[afterIndex]
				this.directory[zIndex].children[afterIndex] = tmp
			} else if (node.level == 3) {
				let zIndex = this.directory.findIndex(item => item.id == node.parent.parent.data.id)
				let zIndexTwo = this.directory[zIndex].children.findIndex(item => item.id == node.parent.data.id)
				let beforeIndex = this.directory[zIndex].children[zIndexTwo].children.findIndex(item => item.id == beforeId)
				let afterIndex = this.directory[zIndex].children[zIndexTwo].children.findIndex(item => item.id == afterId)
				let tmp = this.directory[zIndex].children[zIndexTwo].children[beforeIndex]
				this.directory[zIndex].children[zIndexTwo].children[beforeIndex] = this.directory[zIndex].children[
					zIndexTwo
				].children[afterIndex]
				this.directory[zIndex].children[zIndexTwo].children[afterIndex] = tmp
			} else {
				let zIndex = this.directory.findIndex(item => item.id == node.parent.parent.parent.data.id)
				let zIndexTwo = this.directory[zIndex].children.findIndex(item => item.id == node.parent.parent.data.id)
				let zIndexThree = this.directory[zIndex].children[zIndexTwo].children.findIndex(
					item => item.id == node.parent.data.id
				)
				let beforeIndex = this.directory[zIndex].children[zIndexTwo].children[zIndexThree].children.findIndex(
					item => item.id == beforeId
				)
				let afterIndex = this.directory[zIndex].children[zIndexTwo].children[zIndexThree].children.findIndex(
					item => item.id == afterId
				)
				let tmp = this.directory[zIndex].children[zIndexTwo].children[zIndexThree].children[beforeIndex]
				this.directory[zIndex].children[zIndexTwo].children[zIndexThree].children[beforeIndex] = this.directory[
					zIndex
				].children[zIndexTwo].children[zIndexThree].children[afterIndex]
				this.directory[zIndex].children[zIndexTwo].children[zIndexThree].children[afterIndex] = tmp
			}
			this.directory = [...this.directory]
		},
		onloadInput(node, data) {
			this.treeInputText = node.label
			this.treeId = data.id
			this.$nextTick(() => {
				this.$refs[`input_${data.id}`].focus()
				setTimeout(() => {
					this.$refs[`input_${data.id}`].focus()
				}, 100)
			})
		},
		addEvent() {
			// if (this.treeType === 'create') return
			let id = Date.now()
			let orderNums = this.directory.map(item => item.order_num)
			this.directory.push({
				id: id,
				pid: 0,
				level: 1,
				textbook_id: this.textbook_id,
				order_num: orderNums.length > 0 ? Math.max(...orderNums) + 1 : 1,
				children: [],
				direct_name: '',
				isNew: true
			})
			this.onloadInput({ label: '' }, { id: id })
			this.treeType = 'create'
		},
		treeAddEvent(node, data) {
			// if (this.treeType) return
			if (this.treeId != '') return
			let id = Date.now()
			this.treeType = 'add'
			this.expandList.push(data.id)
			let orderNums = data.children.map(item => item.order_num)
			const newChild = {
				id: id,
				direct_name: '',
				children: [],
				textbook_id: this.textbook_id,
				pid: data.id,
				level: data.level + 1,
				isNew: true,
				order_num: orderNums.length > 0 ? Math.max(...orderNums) + 1 : 1
			}
			if (!data.children) {
				this.$set(data, 'children', [])
			}
			data.children.push(newChild)
			node.expanded = true
			this.onloadInput({ ...node, lable: '' }, { id: id })
		},
		treeRemove(node, data) {
			const parent = node.parent
			const children = parent.data.children || parent.data
			const index = children.findIndex(d => d.id === data.id)
			children.splice(index, 1)
			this.treeType = ''
		},
		treeInputBlur(node, data, event) {
			if (!data.direct_name) {
				if (this.treeType === 'add') {
					this.treeRemove(node, data)
				}
				if (this.treeType === 'create') {
					this.directory.splice(this.directory.length - 1, 1)
				}
			}
			this.treeId = ''
			this.treeType = ''
			this.$refs[`input_${data.id}`]?.blur()
		},
		async treeInputChange(node, data, event) {
			this.treeEditFlag = false
			this.$set(data, 'direct_name', this.treeInputText)
			const { order_num, textbook_id, pid, id } = data
			try {
				if (this.treeType === 'add') {
					if (!event) {
						this.treeRemove(node, data)
					} else {
						const list = await this.$api.resource.createDirectory({
							order_num,
							textbook_id,
							pid,
							direct_name: event
						})
						this.$set(data, 'id', list.id)
					}
				} else if (this.treeType === 'edit') {
					if (!event) {
						await this.treeDeleteEvent(node, data)
					} else {
						await this.editDirectory(id, {
							order_num,
							direct_name: event,
							textbook_id,
							pid
						})
					}
				} else if (this.treeType === 'create') {
					if (!event) {
						this.directory.splice(this.directory.length, 1)
					} else {
						const list = await this.$api.resource.createDirectory({
							order_num,
							textbook_id,
							pid,
							direct_name: event
						})
						this.$set(data, 'id', list.id)
					}
				}
				// this.$refs[`input_${data.id}`]?.blur()
				this.treeId = ''
				// this.treeType = ''
				// await this.getDirectory(this.textbook_id)
			} catch (err) {
				this.getDirectory(this.textbook_id)
			}
		},
		async treeDeleteEvent(node, data) {
			if (this.treeId != '') return
			this.treeType = 'delete'
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					this.treeRemove(node, data)
					await this.deleteDirectory(data.id)
					this.treeType = ''
				})
				.catch(() => {
					this.treeType = ''
					this.getDirectory(this.textbook_id)
				})
		},
		async deleteCourse() {
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
        if (this.menuActiveIndex == 'draft') await this.$api.resource.deleteDraftList({ ids: this.courseRadio })
				else await this.$api.resource.deleteCourseList({ ids: this.courseRadio })
				this.courseRadio = []
				this.getCourses({ did: this.activeTreeId, page_size: 10, page: 1 }, 'reset')
			})
		},
	},
  mounted() {
    document.body.style['overflow-y'] = 'hidden'
  },
  destroyed() {
		document.body.style['overflow-y'] = 'auto'
	},
	watch: {
		treeEditFlag: {
			handler(val) {
				if (!val) {
					this.treeId = ''
					// this.treeType = ''
					// this.getDirectory(this.textbook_id)
				}
			}
		}
	},
	beforeDestroy() {
		const editor = this.editor
		if (editor == null) return
		editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
	},
	computed: {
		yy_ms() {
			return this.params.fb_subject_id == 1 ? 'yy' : this.params.fb_subject_id == 2 ? 'ms' : ''
		}
	}
}
</script>
<style scoped lang="scss">
/deep/ .el-checkbox__label {
	display: none;
}
/deep/ .el-checkbox__inner {
	border-radius: 100%;
}
.courseware-body {
	display: flex;
	flex-direction: column;
	height: calc(100vh - 97px);
	overflow: hidden;
	.ability-detail-header {
		display: flex;
		align-items: center;
		padding: 15px 15px 15px 25px;
		background: #ffffff;
		font-size: 16px;
		cursor: pointer;
	}
	.ability-detail-header:hover {
		color: #ff5e2a;
	}
	.top {
		padding: 10px 20px;
		display: flex;
		background: #ffffff;
		align-items: center;
		/deep/ .el-dropdown {
			display: flex;
			align-items: center;
		}
		.top-line {
			width: 2px;
			height: 75px;
			background: #e1e1ff;
		}
		.top-half {
			padding: 10px;
			flex-basis: 100%;
			display: flex;
			background: #f9f9ff;
			overflow: hidden;
		}
		.top-black-text {
			font-size: 18px;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #393939;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 300px;
		}
		.top-grey-text {
			margin-top: 5px;
			font-size: 16px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #969696;
		}
		.top-blue-text {
			margin-top: 5px;
			font-size: 16px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #1f1f61;
		}
	}
	.content {
		display: flex;
		flex: 1;
		margin-top: 15px;
		overflow: hidden;
		.left {
			width: 466px;
			height: inherit;
			overflow: auto;
			padding: 10px;
			box-sizing: border-box;
			background: #ffffff;
		}
		.left-title {
			font-size: 18px;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #4a4a4a;
		}
		.right {
			flex: 1;
			height: 100%;
			padding: 0 10px;
			margin-left: 10px;
			background: #ffffff;
			overflow-x: hidden;
			overflow-y: scroll;
		}
		.right-header {
			position: sticky;
			top: 0;
			background: #ffffff;
			padding: 10px 0;
			z-index: 9;
		}
		.right-content {
			display: flex;
			flex-wrap: wrap;
			gap: 25px 5%;
			padding-bottom: 20px;
      align-items: flex-start;
		}
		.content-item {
			flex-basis: 30%;
			background: #f8f8f8;
			border-radius: 6px 6px 6px 6px;
			padding: 8px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			.item-radio {
				width: 100%;
				display: flex !important;
				flex-direction: row-reverse;
				/deep/ .el-radio__label {
					display: none;
				}
				margin-bottom: 5px;
			}
			.item.name {
				font-size: 16px;
				font-family: PingFang SC-Bold, PingFang SC;
				font-weight: bold;
				color: #4a4a4a;
				margin-bottom: 5px;
			}
			.item-date {
				font-size: 10px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #848484;
				margin-bottom: 5px;
			}
      .item-draft {
        background: rgba(0,0,0,0.4);
        border-radius: 3px 0px 3px 0px;
        z-index: 1;
      }
			.item-name {
				font-family: PingFang SC-Bold, PingFang SC;
				font-size: 15px;
				font-weight: bold;
				color: #4a4a4a;
				margin-bottom: 5px;
			}
			.item-avtor {
				font-size: 12px;
				font-family: PingFang SC-Bold, PingFang SC;
				color: #4a4a4a;
				flex: 1;
				margin-left: 5px;
			}
		}
		.right-empty {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
	}
	.delete-icon {
		width: 20px;
		height: 20px;
	}
	.empty-icon {
		width: 48%;
	}
	.tree-node {
		display: flex;
		.node-content {
      min-height: 21.99px; // 编辑状态图标按钮高度会撑开
			max-width: 300px;
			white-space: pre-line;
		}
		.node-content-active {
			color: #ff5e2a !important;
		}
		.node-icon-1 {
			width: 24px;
      height: 24px;
      font-size: 24px;
		}
		.node-icon-2 {
			width: 22px;
      height: 22px;
      font-size: 22px;
		}
		.node-icon-3 {
			width: 20px;
      height: 20px;
      font-size: 20px;
		}
		.node-icon-4 {
			width: 18px;
      height: 18px;
      font-size: 18px;
		}
		.node-content-1 {
			color: #4a4a4a;
			font-size: 18px;
			font-weight: bold;
		}
		.node-content-2 {
			color: #4a4a4a;
			font-size: 15px;
			font-weight: 600;
		}
		.node-content-3 {
			color: #4a4a4a;
			font-size: 15px;
			font-weight: 600;
		}
		.node-content-4 {
			color: #7e7e7e;
			font-size: 15px;
			font-weight: 500;
		}
		.node-stop {
			cursor: not-allowed;
		}
	}
	/deep/ .el-tree-node__content {
		min-height: 40px;
		height: inherit;
		padding: 5px;
    background-color: transparent
    // align-items: baseline;
	}
  /deep/ .el-tree-node__content:hover {
    background-color: #F9F9F9 !important;
  }
  /deep/ .is-current>.el-tree-node__content:first-child  {
    background-color: #FFF5F2 !important;
  }
	/deep/ .el-tree-node__expand-icon.el-icon-caret-right {
		color: black;
	}
	/deep/ .is-leaf.el-tree-node__expand-icon.el-icon-caret-right {
		color: transparent !important;
	}
}
.caogao-menu {
  /deep/ .el-menu-item {
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
    padding: 0 5px;
  }
  /deep/ .is-active {
    font-weight: bolder;
  }
}
.slide-fade-enter {
	position: absolute;
	width: 100%;
	transition: all 0.3s ease;
	transform: translateX(0);
	opacity: 1;
}

.slide-fade-leave {
	position: absolute;
	width: 100%;
	transition: all 0.3s ease;
	transform: translateX(100%);
	opacity: 0;
}
.grey-btn {
  background-color: #EDF2F5;
  border-radius: 20px;
  margin-right: 3px;
  cursor: pointer;
  color: #4B4B4B;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  transition: background-color 0.1s;
}
.grey-btn:hover {
  background-color: #D2D9DD;
}
</style>
